import React, { useRef, useState, useEffect } from 'react';
import './MediaCard.css';

export default function MediaCard({ item, onClick, onDelete }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  const [imgError, setImgError] = useState(false);

  // Lazy-load: only render thumbnail when card enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { rootMargin: '300px' }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const isVideo = item.fileType?.startsWith('video');
  const isProcessing = item.status !== 'ready';

  return (
    <div
      ref={ref}
      className={`media-card ${isProcessing ? 'media-card--processing' : ''}`}
      onClick={() => !isProcessing && onClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && !isProcessing && onClick(item)}
      aria-label={item.originalName}
    >
      {visible && (
        <>
          {isProcessing ? (
            <div className="media-card__placeholder">
              <div className="spinner" />
              <span>{item.status === 'failed' ? 'Failed' : 'Processing…'}</span>
            </div>
          ) : item.thumbnailUrl && !imgError ? (
            <img
              className="media-card__thumb"
              src={item.thumbnailUrl}
              alt={item.originalName}
              loading="lazy"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="media-card__placeholder">
              <span>{isVideo ? '🎬' : '🖼'}</span>
            </div>
          )}

          {isVideo && !isProcessing && (
            <span className="media-card__badge">▶</span>
          )}
        </>
      )}

      <button
        className="media-card__delete"
        onClick={(e) => { e.stopPropagation(); onDelete(item); }}
        aria-label="Delete"
        title="Delete"
      >
        ✕
      </button>
    </div>
  );
}
